import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
  Button
} from "reactstrap";

import { InputGroup, InputGroupText, InputGroupAddon, Input } from 'reactstrap';
import DetailedOrderCard from "../../components/DetailedOrderCard/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import { SDK_CHROME } from "../../config/Constants";
import LoadingOverlay from "react-loading-overlay";
import Resonf from "./Resonf";
import navigate from "../../assets/img/navigate.png";

// import AlertDialog from "./AlertDialog";

export default class DeliveryDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().endOf("day"),
      endDate: moment().endOf("day"),
      bookingStartDate: moment().endOf("day"),
      bookingEndDate: moment().endOf("day"),
      pageText: "DELIVERY ORDERS",
      printSdkType: "",
      bookingDateSelected: false,
      spinnerLoading: false,
      screenrefresh:false
    };
  }

 
  
  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary"
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  
  


  componentWillMount() {
    this.checkLoginMode();
  }

  componentDidMount() {
   
    this.pendingDelivery();
  }

  getDeliveryLocation = (userlocation) => {
    let deliveryLocation = "";
    let vehicleString = "";
    let userLocation=userlocation;
      
          console.log('deliveryLocation', deliveryLocation)
          let house = ''
          let addressLine1 = ''
          let addressLine2 = ''
          let landmark = ''
          let pincode = ''
          let city = ''
          
          if(userLocation.house !== null) { house = userLocation.house }
          if(userLocation.addressLine1 !== null) { addressLine1 = userLocation.addressLine1 }  
          if(userLocation.addressLine2 !== null) { addressLine2 = userLocation.addressLine2 }  
          if(userLocation.landmark !== null) { landmark = userLocation.landmark }  
          if(userLocation.pincode !== null) { pincode = userLocation.pincode }  
          if(userLocation.city !== null) { city = userLocation.city }  
          
          deliveryLocation =
            'Address:'
            + ' ' + house
            + ' ' + addressLine1 
            + ' ' + addressLine2
            + ' ' + landmark
            + ' ' + pincode
            + ' ' + city
       
    return deliveryLocation;
  };

  pendingDelivery = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    }

   
    console.log("params", params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "pendingDelivery",
      params
    );

    if (response.error === null) {
      let grandTotal = 0.0;
      for (let i = 0; i < response.data.pendingDelivery.edges.length; i++) {
        grandTotal =
          grandTotal +
          response.data.pendingDelivery.edges[i].node.cart.settlementPrice;
      }

      this.setState({
        spinnerLoading: false,
        orders: response.data.pendingDelivery.edges,
        grandTotal: grandTotal.toFixed(2)
      });
    } else {
      this.setState({ spinnerLoading: false });
    }

    console.log(response,"sa");
  };

  getCountOfItems = (nOrder) => {
    
      let cartItems = nOrder.node.cart.cartItems.edges;
      let quantity = 0;
      
      cartItems.forEach(cartItem => {
        
        if (cartItem.node.status == 'FULFILLED'){
        quantity = quantity + cartItem.node.quantity;
        }
      });
    return quantity;
    
  };
  getUnfulfilledCountOfItems = (nOrder) => {
    
    let cartItems = nOrder.node.cart.cartItems.edges;
    let quantity = 0;
    
    cartItems.forEach(cartItem => {
      
      if (cartItem.node.status == 'UNFULFILLED'){
      quantity = quantity + cartItem.node.quantity;
      }
    });

    return quantity;
  
};
  getUnfulfilledItems = (nOrder) => {
    
    let cartItems = nOrder.node.cart.cartItems.edges;
    let unfulfilled = {}
    cartItems.forEach(cartItem => {
      if (cartItem.node.status == 'UNFULFILLED'){
        unfulfilled[cartItem.node.stock.sku.name] = (cartItem.node.quantity)
      }
    });

    return unfulfilled;
  
};
  handlenavigateclick = (ulocation) =>{
    
    console.log('navigate', ulocation.latitude, ulocation.longitude)
    //console.log('button', nvalue)
    if (ulocation.latitude == null){
      return
    }
      //getDirections(data);
      try{
      if ('geolocation' in navigator) {
        
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if ('coords' in position) {
              
              const { latitude, longitude } = position.coords;
             
                let dest_lat = ulocation.latitude
                let dest_lng = ulocation.longitude
              window.open("https://www.google.com/maps/dir/"+latitude+","+longitude+"/"+dest_lat+","+dest_lng)
             
              // userLocation && setUserLocation(userlocations);
            }
          },
          
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  
      
    
    
  }


  handleclaimclick = (order_id) =>{
    console.log('claim', order_id);
  }
  handledeliveredclick = (event) =>{
    //const value = event.target.value
    //const id = event.target.id;
    //alert(value.node.cart.checkout.userLocation.Latitude);
    console.log('handledeliveredclick')
  }
  updatePickedUp = async (orderId) => {
    let params = {};
    params = {
      input:{
      id: orderId,
      status: 'DISPATCHED'
      }
    };
    let requestManager = new RequestManager();
    
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );
    console.log('updateorder response', response);
    if (response.error === null) {
      console.log('updateorder Success');
      this.state.screenrefresh = !this.state.screenrefresh
      return true;
      
    } else {
      console.log('updateorder Failure');
      return false;
      
    }
  }
  updateDelivered = async (orderId) => {
    let params = {};
    params = {
      input:{
      id: orderId,
      status: 'DELIVERED'
      }
    };
    let requestManager = new RequestManager();
    
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );
    console.log('updateorder response', response);
    if (response.error === null) {
      console.log('updateorder Success');
      this.state.screenrefresh = !this.state.screenrefresh
      return true;
      
    } else {
      console.log('updateorder Failure');
      return false;
      
    }
  }
  
  updateSupportClaim = async (orderId, nclaimSupport) => {
    console.log('updateorder claim',orderId , nclaimSupport )
    let params = {};
    params = {
      input:{
      id: orderId,
      claimSupport: nclaimSupport
      }
    };

    let requestManager = new RequestManager();
    console.log('updateorder params',orderId , nclaimSupport )
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );
    console.log('updateSupportClaim response', response);
    if (response.error === null) {
      console.log('updateSupportClaim Success');
      this.state.screenrefresh = !this.state.screenrefresh
      return true;
      
    } else {
      console.log('updateorder Failure');
      return false;
      
    }
  };




  getClaimedBy = (order) => {
    let delivery_person = "";
    console.log('order delivery person', order.node.delivery);
    if (order && order.node.delivery !== null && order.node.delivery !== undefined) {
      delivery_person =
        "Claimed By: " +
        order.node.delivery.userProfile.firstName + 
        " " +
        order.node.delivery.userProfile.lastName;
    }
    return delivery_person;
  };

  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{this.state.pageText}</h5>
                      </Col>
                
                    </Row>
              
                  </Container>
                </CardHeader>
                <Container fluid>
                    {this.state.orders.map(order => {
                      
                      return (
                        <Card >
                      <div>
                      <div><Button color="success" id={order.node.id}  
                          onClick={()=>{this.handlenavigateclick(order.node.cart.checkout.userLocation)}}><img style={{
                            width: 24,
                            height: 24,
                            marginLeft: 5,
                            objectFit: "contain",
                          }} src={require("../../assets/img/navigate.png")}/>NAVIGATE</Button>
                          {/*(order.node.delivery !== null) && (*/
                            (order.node.status == 'PENDINGDISPATCHED') && (
                            <Button color="warning" onClick={() => {this.updatePickedUp(order.node.id)}}>{"PICK UP"}</Button>
                            )
                            //)
                            }
                          {(order.node.delivery == null) && (
                            <Button color="primary" onClick={() => {this.updateSupportClaim(order.node.id,true)}}>Claim</Button>
                          )}
                          </div>
                          <div style={{fontSize:"11px", fontWeight:"bold"}}>{order.node.orderId}</div>
                          <div style={{fontSize:"12px", color:"blue"}}>{this.getDeliveryLocation(order.node.cart.checkout.userLocation)}</div>
                          <div style={{fontSize:"11px"}}>{order.node.user.phone}</div>
                          <div style={{fontSize:"11px"}}>Delivery Slot {order.node.cart.deliverySlot}</div>
                          <div style={{fontSize:"11px"}}>No of Items :  {this.getCountOfItems(order)}</div>
                          <div style={{fontSize:"11px", color:"red", fontWeight:"bold", fontStyle:"oblique"}}>Unfulfilled Items : {this.getUnfulfilledCountOfItems(order)}</div>
                          <div style={{fontSize:"11px", color:"red", fontStyle:"oblique"}}> {JSON.stringify(this.getUnfulfilledItems(order))}</div>
                          
                          <div style={{fontSize:"11px", color:"brown"}}>{ order.node.status}</div>
                          <div style={{fontSize:"14px", fontWeight:"bold", color:"brown"}}>{this.getClaimedBy(order)}</div>
                          <div style={{fontSize:"11px"}}>{order.node.cart.pickupPoint.store.name}</div>
                          <div>
                          {(order.node.delivery !== null ) && (
                            (order.node.status !== 'PENDINGDISPATCHED') && (
                              <Button color="success" value={order} onClick={() => {this.updateDelivered(order.node.id)}}>DELIVERED</Button>
                            )
                            )}
                            </div>
                        </div>   
                        </Card>  
                      );
                    
                  

                })}
                </Container>
              </Card>
            
        </Container>
      </LoadingOverlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DeliveryDetails/DeliveryDetails.js